import { Box, Grid, Typography, useTheme } from '@mui/material';
import TelegramIcon from './icons/telegram-icon';
import TelegramIcons from './icons/telegram-icons';
import Tiktok from './icons/tiktok';
import Twitch from './icons/twitch';
import TwitterIcon from './icons/twitter-icon';
import WhatsappIcon from './icons/whatsapp-icon';

const AnaliticaSocialNetworks = () => {
    const theme = useTheme();

    const socialButtonStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        borderRadius: '6px',
        padding: '6px 12px',
        transition: 'all 0.2s ease-in-out',
        background: theme.palette.background.darkCard,
        justifyContent: 'center',

        '& .MuiTypography-root': {
            color: theme.palette.text.primary,
        },
        '& svg': {
            fill: theme.palette.text.primary,
        },
        '&:hover': {
            backgroundColor: theme.palette.background,
            transform: 'translateY(-1px)',
        },
        border: '1px solid',
        borderColor: theme.palette.border.main,
    };

    const socialNetworks = [
        {
            id: 'twitter',
            name: 'Twitter',
            icon: <TwitterIcon color="inherit" />,
            url: 'https://twitter.com/AnaliticaLaLiga',
        },
        {
            id: 'tiktok',
            name: 'TikTok',
            icon: <Tiktok color="inherit" width={18} height={18} />,
            url: 'https://www.tiktok.com/@analitica.fantasy',
        },
        {
            id: 'telegram-news',
            name: 'Noticias',
            icon: <TelegramIcon color="inherit" />,
            url: 'https://t.me/+pOyVGp5tSEpkMzBh',
        },
        {
            id: 'telegram-community',
            name: 'Comunidad',
            icon: <TelegramIcons color="inherit" />,
            url: 'https://t.me/+9Qf0bWVpF35jNWEx',
        },
        {
            id: 'twitch',
            name: 'Twitch',
            icon: <Twitch styles={{ width: '20px', height: '20px' }} color="inherit" />,
            url: 'https://www.twitch.tv/donquijotedlc',
        },
        {
            id: 'whatsapp',
            name: 'Whatsapp',
            icon: <WhatsappIcon styles={{ width: '20px', height: '20px' }} color="inherit" />,
            url: 'https://whatsapp.com/channel/0029VawDrasLtOjKouGAfp24',
        },
    ];

    return (
        <Box mb={2}>
            <Typography
                sx={{
                    marginBottom: 1,
                    fontSize: 16,
                    opacity: 0.8,
                }}
            >
                Síguenos en nuestras redes sociales:
            </Typography>
            <Grid
                container
                spacing={2}
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: { xs: 'center', md: 'flex-start' },
                    alignItems: 'center',
                    width: '100%',
                    gap: '8px',
                }}
            >
                {socialNetworks.map((network) => (
                    <Grid
                        key={network.id}
                        onClick={() => window.open(network.url, '_blank')}
                        sx={socialButtonStyle}
                        size={{ xs: 6, md: 4, lg: 2 }}
                    >
                        {network.icon}
                        <Typography fontSize={'14px'}>{network.name}</Typography>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default AnaliticaSocialNetworks;
